import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../theme';

import SupportFormComponent from '../components/support-form';
import VoteFeaturesComponent from '../components/vote-features';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),

    },
    contentRoot: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  }),
);

export default function ConnectPage() {
  const classes = useStyles(baseTheme);
  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography variant="h4" color="primary">
        Connect
      </Typography>
      <Grid item container direction="column">
        <SupportFormComponent />
        {/* <VoteFeaturesComponent /> */}
      </Grid>
    </Grid>
  );
}
